import { Link } from "react-router-dom";
import { Upload } from "lucide-react";
import { Button } from "../../components/ui/Button.jsx";

/**
 * Header trigger — navigates to the dedicated bulk-import route. The
 * import flow lives at /floor-plans/bulk-import as a full page.
 */
export const BulkImportTrigger = () => (
  <Link to="/floor-plans/bulk-import">
    <Button variant="secondary" leftIcon={<Upload className="h-4 w-4" />}>
      Bulk import
    </Button>
  </Link>
);
